import {
	statusmentorshipByID,
	statusmentorshipCreate,
	statusmentorshipDestroy,
	statusmentorshipList,
	statusmentorshipListAll,
	statusmentorshipUpdate,
} from '@/services/jobs/statusmentorships.service'

export default {
	namespaced: true,
	state: {
		// SERVICE STATUSMENTORSHIP
		statusmentorshipList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		statusmentorshipListAll: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		statusmentorship: {},

		// STATUS SERVICE STATUSMENTORSHIP
		statusmentorshipStatus: 'pending',
		statusmentorshipSaveStatus: 'init',
		statusmentorshipDeleteStatus: 'init',
	},
	getters: {
		// SERVICE STATUSMENTORSHIP
		getStatusmentorshipList(state) {
			return state.statusmentorshipList
		},
		// SERVICE STATUSMENTORSHIP
		getStatusmentorshipListAll(state) {
			return state.statusmentorshipListAll
		},
		getStatusmentorship(state) {
			return state.statusmentorship
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE STATUSMENTORSHIP
		getStatusmentorshipDeleteStatus(state) {
			return state.statusmentorshipDeleteStatus
		},
		getStatusmentorshipSaveStatus(state) {
			return state.statusmentorshipSaveStatus
		},
		getStatusmentorshipStatus(state) {
			return state.statusmentorshipStatus
		},
	},
	mutations: {
		// SERVICE STATUSMENTORSHIP
		STATUSMENTORSHIP_LIST(state, value) {
			state.statusmentorshipList = value
		},

		SET_STATUSMENTORSHIP(state, value) {
			state.statusmentorship = value
		},

		// STATUS SERVICE STATUSMENTORSHIP
		STATUSMENTORSHIP_STATUS(state, value) {
			state.statusmentorshipStatus = value
		},
		STATUSMENTORSHIP_SAVE_STATUS(state, value) {
			state.statusmentorshipSaveStatus = value
		},
		STATUSMENTORSHIP_DELETE_STATUS(state, value) {
			state.statusmentorshipDeleteStatus = value
		},
	},
	actions: {
		async fetchStatusmentorshipList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('STATUSMENTORSHIP_STATUS', 'pending')
			commit('STATUSMENTORSHIP_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})

			try {
				const { data } = await statusmentorshipList(params)
				commit('STATUSMENTORSHIP_STATUS', 'init')
				commit('STATUSMENTORSHIP_LIST', data)
				return data
			} catch (error) {
				commit('STATUSMENTORSHIP_STATUS', 'init')
				throw error
			}
		},
		async fetchStatusmentorshipListAll({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('STATUSMENTORSHIP_STATUS', 'pending')
			commit('STATUSMENTORSHIP_LIST', {
				data: [],
				meta: { pagination: { total: 0 } },
			})

			try {
				const { data } = await statusmentorshipListAll(params)
				commit('STATUSMENTORSHIP_STATUS', 'init')
				commit('STATUSMENTORSHIP_LIST', data)
				return data
			} catch (error) {
				commit('STATUSMENTORSHIP_STATUS', 'init')
				throw error
			}
		},
		async fetchStatusmentorshipByID({ commit }, params) {
			commit('STATUSMENTORSHIP_STATUS', 'pending')
			try {
				const { data } = await statusmentorshipByID(params)
				commit('STATUSMENTORSHIP_STATUS', 'init')
				commit('SET_STATUSMENTORSHIP', data.data)
				return data
			} catch (error) {
				commit('STATUSMENTORSHIP_STATUS', 'init')

				return error
			}
		},
		async saveNewStatusmentorship({ commit }, params) {
			commit('STATUSMENTORSHIP_SAVE_STATUS', 'pending')
			try {
				const { data } = await statusmentorshipCreate(params)
				commit('STATUSMENTORSHIP_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('STATUSMENTORSHIP_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateStatusmentorship({ commit }, params) {
			commit('STATUSMENTORSHIP_SAVE_STATUS', 'pending')
			try {
				const { data } = await statusmentorshipUpdate(params)
				commit('STATUSMENTORSHIP_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('STATUSMENTORSHIP_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteStatusmentorshipByID({ commit }, params) {
			commit('STATUSMENTORSHIP_DELETE_STATUS', 'pending')
			try {
				const { data } = await statusmentorshipDestroy(params)
				commit('STATUSMENTORSHIP_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('STATUSMENTORSHIP_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
